import cardmarketLogoUrl from '../../assets/auto-prices/cardmarket.jpg';
import { cn } from '../../utils';

type Props = {
    href?: string | null;
    ariaLabel?: string;
    className?: string;
};

export function CardmarketProductLink({
    href,
    ariaLabel = 'Відкрити на Cardmarket',
    className,
}: Props) {
    if (!href) return null;

    return (
        <a
            href={href}
            target="_blank"
            rel="nofollow external noopener noreferrer"
            className={cn(
                'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-input bg-background transition-colors hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none',
                className,
            )}
            aria-label={ariaLabel}
            title="Cardmarket"
            data-testid="cardmarket-product-icon-link"
        >
            <img
                src={cardmarketLogoUrl}
                alt=""
                aria-hidden="true"
                className="h-5 w-5 rounded-sm object-contain"
            />
        </a>
    );
}
